<template>
	<div>
		<breadcrumb :routerList="[{to:'/contract-detail',title:'合同管理'},{title:'合同详情'}]"/>
		<div class="h-content">
			<div class="h-piece">
				<div class="h-formLine weekplandetail">
					<el-form :model="formInline" label-position="right" :inline="true"  class="demo-ruleForm h-formbLine">
						<el-form-item label="合同名称" class="h-elformWrap-2">
							<el-input readonly v-model="formInline.contractName"></el-input>
						</el-form-item>
						<el-form-item label="合同类型" class="h-elformWrap-2">
							<el-input readonly v-model="formInline.contractCatecoryName"></el-input>
						</el-form-item>
						<el-form-item label="商务合同号" class="h-elformWrap-2">
							<el-input readonly v-model="formInline.businessContractCode"></el-input>
						</el-form-item>
						<el-form-item label="关联项目" class="h-elformWrap-2" v-if="!zlflag && !dlsflag">
							<el-input readonly v-model="formInline.pid"></el-input>
						</el-form-item>
						<el-form-item :label="customerlabel" class="h-elformWrap-2">
							<el-input readonly v-model="formInline.customerName"></el-input>
						</el-form-item>
						<!-- <el-form-item label="产品大类" class="h-elformWrap-2" v-if="zlflag">
                           <el-input readonly v-model="formInline.productType"></el-input>
                         </el-form-item>
                         <el-form-item label="产品型号" class="h-elformWrap-2" v-if="zlflag">
                           <el-input readonly v-model="formInline.productCode"></el-input>
                         </el-form-item>
                         <el-form-item label="产品名称" class="h-elformWrap-2" v-if="zlflag">
                           <el-input readonly v-model="formInline.productName"></el-input>
                         </el-form-item>
                         <el-form-item label="租赁数量" class="h-elformWrap-2" prop="rentNum" v-if="zlflag">
                           <el-input readonly v-model="formInline.rentNum"></el-input>
                         </el-form-item> -->
						<el-form-item label="租赁时间" class="h-elformWrap-2" prop="rentTime" v-if="zlflag && !jzxFlag">
							<el-col class="yearIcon">
								<el-input readonly v-model="formInline.rentTime">
								</el-input>
							</el-col>
						</el-form-item>
						<!--<el-form-item label="保修时间" class="h-elformWrap-2" prop="guaranteeTime" v-if="zlflag">-->
						<!--<el-col class="yearIcon">-->
						<!--<el-input readonly v-model="formInline.guaranteeTime">-->
						<!--</el-input>-->
						<!--</el-col>-->
						<!--</el-form-item>-->
						<el-form-item label="LEG合同编号" class="h-elformWrap-2" v-if="formInline.contractType===1 && !cgflag">
							<el-input readonly v-model="formInline.contractCode"></el-input>
						</el-form-item>
						<el-form-item label="销售渠道" class="h-elformWrap-2" v-if="!cgflag&&!zlflag">
							<el-input readonly v-model="formInline.salechannelName"></el-input>
						</el-form-item>
						<el-form-item label="合同金额" class="h-elformWrap-2 h-moneyIcon" v-if="!cgflag && !jzxFlag">
							<el-input readonly v-model="formInline.contractAmount"></el-input>
						</el-form-item>
						<el-form-item label="合同状态" class="h-elformWrap-2" v-if="formInline.contractType===1&&!cgflag">
							<el-input readonly v-model="formInline.contractStatus"></el-input>
						</el-form-item>
						<el-form-item label="租赁类型" class="h-elformWrap-2" prop="zltype" v-if="zlflag">
							<el-select v-model="formInline.zltype" :v="formInline.zltype" disabled placeholder="请选择" @change="selectZlProduct1()">
								<el-option v-for="(item) in zltypeList"
										   :key="item.code"
										   :label="item.name"
										   :value="item.code">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="租赁方式" class="h-elformWrap-2"  v-if="zlflag && !jzxFlag" prop="rentType">
							<el-select v-model="formInline.rentType" placeholder="请选择"
									   :clearable="true" filterable disabled>
								<el-option label="Round Trip" value="roundtrip"></el-option>
								<el-option label="长期" value="longterm"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="租赁天数" class="h-elformWrap-2" v-if="jzxFlag">
							<el-input readonly v-model="formInline.rentTime"></el-input>
						</el-form-item>
						<el-form-item label="合同开始时间" class="h-elformWrap-2">
							<el-input readonly v-model="formInline.contractStarttime"></el-input>
						</el-form-item>
						<el-form-item label="合同结束时间" class="h-elformWrap-2">
							<el-input readonly v-model="formInline.contractEndtime"></el-input>
						</el-form-item>
						<el-form-item label="付款日期" class="h-elformWrap-2">
							<el-input readonly v-model="formInline.payDate"></el-input>
						</el-form-item>
						<el-form-item label="是否附加损坏豁免" class="h-elformWrap-2"  v-if="jzxFlag" prop="isShhm">
							<el-select v-model="formInline.isShhm" placeholder="请选择"
									   :clearable="true" filterable disabled>
								<el-option label="是" value=1></el-option>
								<el-option label="否" value=0></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="提箱地点"  v-if="jzxFlag" class="h-elformWrap-2">
							<el-input v-model="formInline.rentPlace" readonly></el-input>
						</el-form-item>
						<el-form-item label="还箱地点"  v-if="jzxFlag" class="h-elformWrap-2">
							<el-input v-model="formInline.returnPlace" readonly></el-input>
						</el-form-item>
						<el-form-item label="是否加急"  v-if="jzxFlag" class="h-elformWrap-2" prop="isJj">
							<el-select v-model="formInline.isJj" placeholder="请选择"
									   :clearable="true" filterable disabled>
								<el-option label="是" value=1></el-option>
								<el-option label="否" value=0></el-option>
							</el-select>
						</el-form-item>
						<!--<el-form-item label="押金金额" class="h-elformWrap-2 h-moneyIcon" v-if="!cgflag">-->
						<!--<el-input readonly v-model="formInline.contractCashPledge"></el-input>-->
						<!--</el-form-item>-->
						<el-form-item label="租赁类型" class="h-elformWrap-2" prop="zltype" v-if="zlflag">
							<el-select v-model="formInline.zltype" :v="formInline.zltype" placeholder="请选择" @change="selectZlProduct1()">
								<el-option v-for="(item) in zltypeList"
										   :key="item.code"
										   :label="item.name"
										   :value="item.code">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="付款条件" class="h-elformWrap-1" v-if="!cgflag && !zlflag && !bzflag&&!dlsflag">
						</el-form-item>
						<el-form-item label="物流方式" class="h-elformWrap-2" v-if="cgflag">
							<el-input readonly v-if="formInline.wuliufangshi==1" value="海尔自有物流"></el-input>
							<el-input readonly v-if="formInline.wuliufangshi==2" value="供应商直发"></el-input>
							<el-input readonly v-if="formInline.wuliufangshi==3" value="海尔自有物流和供应商直发皆可"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<div class="h-pieceInCon3 h-mrt0 h-mrl100" v-if="!cgflag&&!zlflag&&!bzflag&&!dlsflag">
					<div class="h-formLine h-mrb-38">
						<el-form :model="formInline" label-position="right" :inline="true"  class="demo-ruleForm h-formbLine">
							<el-form-item label="现金" class="h-elformWrap-2">
								<el-col :span="10" class="h-percentageIcon">
									<el-input readonly v-model="formInline.cashRatio"></el-input>
								</el-col>
								<el-col class="line h-txtCenter h-zIcon" :span="4"><img src="../../../assets/images/h-zhunhua-icon.png"></el-col>
								<el-col :span="10" class="h-moneyIcon2">
									<el-input readonly v-model="formInline.cashAmount"></el-input>
								</el-col>
							</el-form-item>
							<el-form-item label="信贷" class="h-elformWrap-2">
								<el-col :span="10" class="h-percentageIcon">
									<el-input readonly v-model="formInline.creditRatio"></el-input>
								</el-col>
								<el-col class="line h-txtCenter h-zIcon" :span="4"><img src="../../../assets/images/h-zhunhua-icon.png"></el-col>
								<el-col :span="10" class="h-moneyIcon2">
									<el-input readonly v-model="formInline.creditAmount"></el-input>
								</el-col>
							</el-form-item>
						</el-form>
					</div>
				</div>
				<div v-if="cgflag">
					<div class="h-pieceTitle2" style="margin:5px 0 16px 10px">
						<h1>产品信息</h1>
					</div>
					<el-form ref="form5" :model="formInline" v-if="!selectProFlag">
						<el-table
								ref="multipleTable"
								:data="formInline.productList"
								stripe
								border
								style="width: 100%"
						>
							<el-table-column
									type="index"
									label="#" width="40">
							</el-table-column>
							<el-table-column
									prop="productId"
									label="产品型号" width="160">
							</el-table-column>
							<el-table-column
									prop="productName"
									:show-overflow-tooltip="true"
									label="产品名称" width="180">
							</el-table-column>
							<el-table-column
									prop="oemDesc"
									:show-overflow-tooltip="true"
									label="规格型号" width="180">
							</el-table-column>
							<el-table-column
									prop="unitPrice"
									label="产品价格" width="140">
							</el-table-column>
							<el-table-column
									prop="currency"
									min-width="100"
									:show-overflow-tooltip="true"
									label="币种">
								<template slot-scope="scope">
									{{scope.row.currency | dictname('YLCurrency')}}
								</template>
							</el-table-column>
							<el-table-column
									prop="shuilv"
									label="发票税率" width="140">
								<template scope="scope">
									<brselect category="cgshuilv" :v="scope.row.shuilv" :disabled="!selectProFlag" v-model="scope.row.shuilv"/>
								</template>
							</el-table-column>
							<el-table-column
									prop="cgjingli"
									label="采购经理">
								<template scope="scope">
									<brselect :multiple="true"
											  category="cg_manage"
											  v-model="scope.row.cgjingli"
											  :disabled="!selectProFlag"
											  :v="scope.row.cgjingli"/>
								</template>
							</el-table-column>
						</el-table>
					</el-form>
					<el-form ref="form5" :model="formInline" v-if="selectProFlag">
						<el-table
								ref="multipleTable"
								:data="formInline.productList"
								style="width: 100%"
						>
							<el-table-column
									prop="productId"
									label="产品型号"
									width="140"
							>
								<template slot-scope="scope">
									<el-input class="h-tableInput" v-model.trim="scope.row.productId" style="height: 0.35rem;"
											  placeholder="请输入" @change="selectDetailModel(scope.row)"></el-input>
								</template>
							</el-table-column>
							<el-table-column
									prop="productName"
									:show-overflow-tooltip="true"
									label="产品名称" width="140">
							</el-table-column>
							<el-table-column
									prop="oemDesc"
									:show-overflow-tooltip="true"
									label="规格型号" width="140">
							</el-table-column>
							<el-table-column
									prop="unitPrice"
									label="产品价格"
									min-width="110"
							>

								<template slot-scope="scope">
									<el-input v-model="scope.row.unitPrice"
											  placeholder="请输入"
											  @keyup.native='keyupEvent($event,input)'
											  class="DshuR h-tableInput" auto-complete="off"></el-input>
								</template>
							</el-table-column>
							<el-table-column
									prop="currency"
									min-width="120"
									:show-overflow-tooltip="true"
									label="币种">
								<template slot-scope="scope">
									<brselect category="YLCurrency" :v="scope.row.currency" v-model="scope.row.currency"/>
								</template>
							</el-table-column>
							<el-table-column
									prop="shuilv"
									label="发票税率" width="140">
								<template scope="scope">
									<brselect category="cgshuilv" :v="scope.row.shuilv" v-model="scope.row.shuilv"/>
								</template>
							</el-table-column>
							<el-table-column
									prop="cgjingli"
									label="采购经理">
								<template scope="scope">
									<brselect :multiple="true"
											  category="cg_manage"
											  v-model="scope.row.cgjingli"
											  :v="scope.row.cgjingli"/>
								</template>
							</el-table-column>
							<el-table-column
									label="操作"
									width="100"
									fixed="right">
								<template slot-scope="scope">
									<el-button type="text" size="small"
											   @click="delzhongbiao(scope.$index,scope.row)">删除
									</el-button>

								</template>
							</el-table-column>
						</el-table>
						<div v-if="selectProFlag" class="h-tableAdd" @click="showProcuct1">
							<a>新增一行</a>
						</div>
					</el-form>
				</div>
				<div v-if="cgflag || (zlflag && formInline.zltype == '1')">
					<div class="h-pieceTitle2" style="margin:25px 0 16px 10px">
						<h1>付款节点</h1>
					</div>
					<el-form ref="form3" :model="formInline" :rules="rules">
						<el-table
								ref="multipleTable"
								:data="formInline.paymentList"
								style="width: 100%"
						>
							<el-table-column
									type="index"
									width="40"
									label="#">
							</el-table-column>
							<el-table-column
									label="节点名称">
								<template scope="scope">
									<el-form-item :prop="'paymentList.'+scope.$index+'.nodeName'" :rules="rules.nodeName" ref="bili2" style="margin-bottom: 0;">
										<!--				                <el-input v-model="scope.row.nodeName" :readonly="!scope.row.newflag"></el-input>-->
										<!--				                <el-input v-model="scope.row.nodeName"></el-input>-->
										<brselect category="payment_node" :v="scope.row.nodeName" :disabled="!selectProFlag" v-model="scope.row.nodeName" clearable />
									</el-form-item>
								</template>
							</el-table-column>
							<el-table-column
									prop="paymentRatio"
									label="付款比例(%)" width="150">
								<template scope="scope">
									<el-form-item :prop="'paymentList.'+scope.$index+'.paymentRatio'" :rules="rules.paymentRatio" style="margin-bottom: 0;">
										<el-input @blur="linkMoney(scope.$index,'ratio')" :disabled="!selectProFlag" v-model="scope.row.paymentRatio"></el-input>
									</el-form-item>
								</template>
							</el-table-column>
							<el-table-column
									label="操作"
									fixed="right"
									width="150">
								<template slot-scope="scope">
									<el-button type="text"  v-if="selectProFlag" @click="delIndex(scope.$index)">删除</el-button>
									<el-button type="text" v-if="selectProFlag" @click="copyIndex(scope.row)">复制</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-form>
					<div class="h-tableAdd" @click="adds" v-if="selectProFlag">
						<a>新增一行</a>
					</div>

				</div>
				<div class="h-formLine h-mrt40 weekplandetail1">
					<el-form :model="formInline" label-position="right" :inline="true"  class="demo-ruleForm h-formbLine">
						<el-form-item label="合同附件" class="h-elformWrap-1 h-formRbtnOut h-formRbtnOut2" style="width: 100%;" prop="name">
							<brupload :refid="this.contractId" reftype="合同附件" :uploadflag="false" :delflag="false"
									  :tpFlag = 'true' :isTpAndPdf = 'true'
							></brupload>
						</el-form-item>
						<el-form-item label="审批意见" class="h-elformWrap-2 " style="margin:20px" :required="true">
							<el-input v-model="formInline.shenpiyijian" placeholder="请输入"
							></el-input>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="h-txtCenter h-mrt60">
				<el-button class="h-btn h-bBtn h-bgwhite" @click="routerPath">返回</el-button>
				<el-button class="h-btn h-bBtn h-bgred" @click="updateShenpi(1)" >驳回</el-button>
				<el-button class="h-btn h-bBtn h-bggreen"  @click="updateShenpi(2)">通过</el-button>
				<el-button class="el-button h-btn el-button--default" v-if="this.showinstid" @click="chakanjindu()">跟踪</el-button>
				<el-button class="h-btn h-bBtn"  v-if="_user.usercode == formInline.spcode && formInline.pass==0" @click="updateShenpi(3)">重新提交</el-button>
			</div>
			<viewhistory :visible.sync="showhistory" v-if="showhistory" :id="showinstid"/>
		</div>
	</div>
</template>

<script>
	import ss from "../../../api/SystemService";
	import util from "../../../utils/util";
	import uploaddown from '../../../utils/updownfile';
	import big from "big.js";
	export default {
		name:'leftMenu',
		data() {
			return {
				zltypeList:[
					{code:"1",name:"房屋"},
					{code:"2",name:"疫苗车"},
					{code:"3",name:"集装箱"}
				],
				customerlabel:"客户名称",
				cgflag:false,
				zlflag:false,
				bzflag:false,
				dlsflag:false,
				showhistory:false,
				selectProFlag:false,
				//表单
				formInline:{
					zltype:"",
					contractName:"",
					pid:"",
					customerCode:"",
					salechannelCode:"",
					contractCatecory:"",
					contractAmount:"",
					contractStatus:"",
					contractStarttime:"",
					userNum:"",
					contractEndtime:"",
					contractCashPledge:"",
					paymentList:[{nodeName:"",newflag:false,paymentRatio:"",posnr:"",
						paymentAmount:"",netValue:"",paymentDays:"",isNeedcred:"",billPayMonty:"",billDate:""}],
					zlList:[
						{
							productType:'',
							productCode:'',
							rentNum:'',
							productName:'',
							productUnitPrice:'',
							pickerOptions2:[]
						}
					],
					fukuanobj:[
						{
							nodeName:"押金",
							newflag:false,
							paymentRatio:"",
							paymentAmount:"",
							posnr:"",
							netValue:"",
							paymentDays:"",
							billPayMonty:""
						}
					],
					productCode:"",
					productName:"",
					productPrice:"",
					productType:"",
					rentNum:"",
					rentTime:"",
					guaranteeTime:"",
					productList:[],
					zsyzq:"",
					payDate:"",
					businessContractCode:"",
					rentType:"",
					isShhm:0,
					isJj:0,
					rentPlace:"",
					returnPlace:"",
					rentPrice:"",
					contractAgent:"",
					saleareaCode:"",
					status:"",
					isZc:"",
					lianqun:"",
					salesCity:"",
				},
				contractId:this.$route.query.key,
				showinstid:null,
				//多选
				checkList:[],
				fileList:[],
				zlxh:[
					{
						productType:'NA4',
						productCode:'BF0260B04',
						productName:'DW-25W198',
						rentNum:'8'
					}
				],
				fukuanobj:[
					{
						nodeName:"",
						newflag:false,
						paymentRatio:"",
						paymentAmount:"",
						netValue:"",
						paymentDays:"",
						billPayMonty:""
					}
				],
				jzxFlag:false,
				fileList:[],
				rules:{
					contractName: [
						{ required: true, message: '请输入合同名称', trigger: 'blur' },
					],
					pid: [
						{ required: true, message: '请输入关联项目编码', trigger: 'blur' },
					],
					customerCode: [
						{ required: true, message: '请先选择合同类型', trigger: 'change' },
					],
					salechannelCode: [
						{ required: true, message: '请选择销售渠道', trigger: 'change' },
					],
					saleareaCode: [
						{ required: true, message: '请选择销售省区', trigger: 'change' },
					],
					salesCity: [
						{ required: true, message: '请选择销售地市', trigger: 'change' },
					],
					contractAmount: [
						{ required: true, message: '请输入合同金额', trigger: 'blur' },
						{ type : 'number', message:"必须为数字值"}
					],
					contractCashPledge:[
						{ required: true, message: '请输入押金金额', trigger: 'blur' },
						{ type : 'number', message:"必须为数字值"}
					],
					contractCatecory: [
						{ required: true, message: '请选择合同类型', trigger: 'change' },
					],
					contractAgent: [
						{ required: true, message: '请选择类型', trigger: 'change' },
					],
					oneLevelAgentName: [
						{ required: true, message: '请输入经销商', trigger: 'change' },
					],
					contractStarttime: [
						{ required: true, message: '请输入合同开始时间', trigger: 'blur' },
					],
					contractEndtime: [
						{ required: true, message: '请输入合同结束时间', trigger: 'blur' },
					],
					condition: [
						{ required: true, message: '请输入付款条件', trigger: 'change' },
					],
					productCode: [
						{ required: true, message: '请先选择关联项目', trigger: 'blur' },
					],
					productName: [
						{ required: true, message: '请先选择关联项目', trigger: 'blur' },
					],
					shuilv: [
						{ required: true, message: '请输入发票税率', trigger: 'change' },
						{ type : 'number', message:"必须为数字值"}
					],
					/*					wuliufangshi:[
                                            { required: true, message: '请选择物流方式', trigger: 'change' },
                                        ],*/
					nodeName:[
						{ required: true, message: '请输入节点名称', trigger: 'blur' },
					],
					paymentRatio:[
						{ required: true, message: '请输入付款比例', trigger: 'blur' },
					],
					paymentAmount:[
						{ required: true, message: '请输入付款金额', trigger: 'blur' },
					],
					netValue:[
						{ required: true, message: '请输入净价值', trigger: 'blur' },
					],
					/*					paymentDays:[
                                            { required: true, message: '请输入账期', trigger: 'blur' },
                                        ],
                                        isNeedcred:[
                                            { required: true, message: '请选择是否需要凭证', trigger: 'change' },
                                        ],*/
					productPrice:[
						{ required: true, message: '请先选择关联项目', trigger: 'blur' },
					],
					rentTime:[
						{ required: true, message: '请输入租赁时间', trigger: 'blur' },
						{ type : 'number', message:"必须为数字值"}
					],
					guaranteeTime:[
						{ required: true, message: '请输入保修时间', trigger: 'blur' },
						{ type : 'number', message:"必须为数字值"}
					],
					billDate:[
						{ required: true, message: '请输入计划开票时间', trigger: 'blur' },
					],
					// zsyzq:[
					// 	{ required: true, message: '请选择收益分摊周期', trigger: 'change' },
					// ],
					zltype:[
						{ required: true, message: '请选择租赁类型', trigger: 'change' },
					],
					rentType:[
						{ required: true, message: '请选择租赁方式', trigger: 'change' },
					],
					rentTime:[
						{ required: true, message: '请选择租赁天数', trigger: 'change' },
					],
					rentPlace:[
						{ required: true, message: '请输入提箱点', trigger: 'change' },
					],
					returnPlace:[
						{ required: true, message: '请输入还箱点', trigger: 'change' },
					],
					isShhm:[
						{ required: true, message: '请选择是否损坏豁免', trigger: 'change' },
					],
					isJj:[
						{ required: true, message: '请选择是否加急', trigger: 'change' },
					],
					userNum: [
						{ required: true, message: '请填写用户个数', trigger: 'change' },
					],
				},
			}
		},
		methods: {
			routerPath(){
				this.$router.back();
			},
			linkMoney(index,data){

				if(data == "ratio") {
					this.formInline.paymentList[index].paymentAmount=new big(this.formInline.contractAmount).times(this.formInline.paymentList[index].paymentRatio).div(100).toFixed(2).toString();
					this.formInline.paymentList[index].netValue=new big(this.formInline.paymentList[index].paymentAmount).div(1.13).toFixed(2).toString();



				}else if(data == "amount"){
					this.formInline.paymentList[index].paymentRatio=new big(this.formInline.paymentList[index].paymentAmount).div(this.formInline.contractAmount).times(100).toFixed(2).toString();
					this.formInline.paymentList[index].netValue=new big(this.formInline.paymentList[index].paymentAmount).div(1.13).toFixed(2).toString();


				}else if(data == "net"){
					this.formInline.paymentList[index].paymentAmount=new big(this.formInline.paymentList[index].netValue).times(1.13).toFixed(2).toString();
					this.formInline.paymentList[index].paymentRatio=new big(this.formInline.paymentList[index].paymentAmount).div(this.formInline.contractAmount).times(100).toFixed(2).toString();


				}else if (data == "yj") {
					this.formInline.fukuanobj[index].paymentAmount=new big(this.formInline.contractAmount).times(this.formInline.fukuanobj[index].paymentRatio).div(100).toFixed(2).toString();
					this.formInline.fukuanobj[index].netValue=new big(this.formInline.fukuanobj[index].paymentAmount).div(1.13).toFixed(2).toString();
				}
				this.formInline.paymentList[index].posnr = (index + 1) ;

			},
			selectDetailModel(v){
				ss.contractService.getOemProducts(v.productId).then(rd => {
					if(rd.f){
						v.productId = rd.msg.materialCode;
						v.productName = rd.msg.materialDescrition;
						v.oemDesc = rd.msg.oemDesc;
					}
				});
			},
			showProcuct1(){
				var product = {};
				product.productId = "";
				product.productName = "";
				product.oemDesc = "";
				product.unitPrice = 0;
				product.currency = "";
				product.shuilv = "";
				product.cgjingli = "";
				this.formInline.productList.push(product);
			},
			//删除子件信息
			delzhongbiao(v, row) {
				this.formInline.productList.splice(v, 1);
			},
			keyupEvent(e,input){
				e.target.value=e.target.value.replace(/[^\d.]/g, '');
				e.target.value=e.target.value.replace(/\.{2,}/g, '.');
				e.target.value=e.target.value.replace(/^\./g, '0.');
				e.target.value=e.target.value.replace(/^\d*\.\d*\./g, e.target.value.substring(0,e.target.value.length-1));
				e.target.value=e.target.value.replace(/^0[^\.]+/g, '0')
				e.target.value=e.target.value.replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
				this.input=e.target.value
			},
			//删除子件信息
			delzhongbiao(v, row) {
				this.formInline.productList.splice(v, 1);
			},
			delIndex(index){
				this.formInline.paymentList.splice(index, 1)
			},
			delIndex1(index){
				this.formInline.zlList.splice(index, 1)
			},
			copyIndex(data){
				this.formInline.paymentList.push({nodeName:data.nodeName,paymentRatio:data.paymentRatio,paymentDays:data.paymentDays,
					newflag:true,billDate:data.billDate,billPayMonty:data.billPayMonty});
			},
			adds(){
				var a = {nodeName:"",paymentRatio:"",paymentAmount:"",netValue:"",posnr:"",
					paymentDays:"",isNeedcred:"",newflag:true,billPayMonty:"",billDate:""};
				this.formInline.paymentList.push(a)
			},
			//查看进度
			chakanjindu(q){
				this.showhistory = true;
			},
			updateShenpi(flag) {
				if(flag == 3){
					this.$msg.confirm("确认提交？",()=>{
						this.formInline.shenpiFlag = flag;
						this.formInline.instid = this.$route.query.instid;
						this.formInline.taskid = this.$route.query.taskid;
						this.formInline.productListS = this.formInline.productListS;
						ss.contractService.updateShenpiHhcg(this.formInline).then(rd => {
							this.$router.push("/personal/dealCenter");
							this.$msg.msgs(rd.msg);
						})
					})
				}else{
					if (flag == '1') {
						if (!this.formInline.shenpiyijian) {
							this.$msg.msge("驳回必须输入审批意见！");
							return;
						}
					}
					this.$msg.confirm("确定审批吗？",()=>{
						this.formInline.shenpiFlag = flag;
						this.formInline.instid = this.$route.query.instid;
						this.formInline.productList = this.formInline.productListS;
						this.formInline.taskid = this.$route.query.taskid;
						ss.contractService.updateShenpiHhcg(this.formInline).then(rd => {
							this.$router.push("/personal/dealCenter");
							this.$msg.msgs(rd.msg);
						})
					})
				}
			},
			//获取当前登录人公司
			getCompany(){
				ss.contractService.getUserCompany().then(rd => {
					if(rd.f){
						if(rd.msg == '0PN0' || rd.msg == '1R60' || rd.msg == '1S00'){
							this.selectProFlag = true;
							//康盛跟海盛杰的人获取全部可用供应商
							ss.ProService.getAllSupplier().then(rd => {
								console.log(rd, "optionsSupplier");
								if(rd.f){
									for(var i = 0;i<rd.msg.length;i++){
										var data = rd.msg[i];
										this.customerList.push({"usercode":data.usercode,"username":data.userName});
									}
								}
							})
						}
					}
				})
			},
			getSpanArr() {
				this.spanArr = [];
				this.tableData3.forEach((item, index) => {
					if (index === 0) {
						this.spanArr.push(1);
						this.position = 0;
					} else {
						if (this.tableData3[index].materialid === this.tableData3[index - 1].materialid) {
							this.spanArr[this.position] += 1;
							this.spanArr.push(0);
						} else {
							this.spanArr.push(1);
							this.position = index;
						}
					}
				})
			},
			objectSpanMethod({row, column, rowIndex, columnIndex}) {
				if ( columnIndex == 1 ) {
					const _row = this.spanArr[rowIndex];
					const _col = _row > 0 ? 1 : 0;
					return {
						rowspan: _row,
						colspan: _col
					}
				}
			},
			deleteTask() {
				this.$msg.confirm("待办删除后此流程将无法继续推行，确认删除？",()=>{
					this.formInline.taskid = this.$route.query.taskid;
					ss.taskservice.deleteTask(this.formInline.taskid).then(rd => {
						this.$msg.msgs(rd.msg);
						//刷新右上角的代办个数
						this.$store.dispatch("searchTasktotal")
						//跳转回系统的代办列表
						this.$router.push({path:'/personal/dealCenter'})
					})
				})
			}
		},
		mounted() {
			this.taskstatus = this.$route.query.taskstatus||0;
			this.showinstid = this.$route.query.instid||null;
			this.contractId = this.$route.query.key||null;

			if(null != this.showinstid && this.showinstid != ''){
				ss.contractService.selectByInstidShenpi(this.showinstid).then(rd => {
					this.formInline = rd.obj;
					this.contractId = rd.obj.id;
					console.log(this.formInline,"1111");
					var cpmcodes = _.join(_.map(rd.obj.productListS,"productId"),",");
					ss.chanpin.selectAllBymCodes({codes:cpmcodes}).then(rd => {
						this.tableData3 = rd.obj;
						this.getSpanArr();
					})
					if (this.formInline.contractCatecory == "CT-CG") {
						this.cgflag = true;
						this.customerlabel = "供应商名称";
					} else if (this.formInline.contractCatecory == "CT-ZL") {
						rd.obj['fukuanobj'] = [];
						this.formInline = rd.obj;

						this.formInline.fukuanobj.push({nodeName:"押金",paymentRatio:rd.obj.contractCashRadio,paymentDays:rd.obj.contractCashDays,
							newflag:false,netValue:rd.obj.contractCashNetValue,paymentAmount:rd.obj.contractCashPledge});
						this.zlflag = true;
					} else if (this.formInline.contractCatecory == "CT-BZ") {
						this.bzflag = true;
					}
					//获取附件相关信息
					var yuming =window.location.host
					var  refid = this.contractId
					// console.log(this.refid)
					uploaddown.listdownfile({refid:this.contractId, reftype: '合同附件'}).then(res => {
						console.log(res, '合同附件');
						this.fileList = res.obj
					})
				});
			}

			if(null != this.contractId && this.contractId != ''){
				ss.contractService.detail(this.contractId).then(rd => {
					this.formInline = rd.obj;
					this.contractId = rd.obj.id;
					console.log(this.formInline,"1111");
					var cpmcodes = _.join(_.map(rd.obj.productListS,"productId"),",");
					ss.chanpin.selectAllBymCodes({codes:cpmcodes}).then(rd => {
						this.tableData3 = rd.obj;
						this.selectProFlag = true;
						this.getSpanArr();
					})
					if (this.formInline.contractCatecory == "CT-CG") {
						this.cgflag = true;
						this.customerlabel = "供应商名称";
					} else if (this.formInline.contractCatecory == "CT-ZL") {
						rd.obj['fukuanobj'] = [];
						this.formInline = rd.obj;

						this.formInline.fukuanobj.push({nodeName:"押金",paymentRatio:rd.obj.contractCashRadio,paymentDays:rd.obj.contractCashDays,
							newflag:false,netValue:rd.obj.contractCashNetValue,paymentAmount:rd.obj.contractCashPledge});
						this.zlflag = true;
					} else if (this.formInline.contractCatecory == "CT-BZ") {
						this.bzflag = true;
					}
					//获取附件相关信息
					var yuming =window.location.host
					var  refid = this.contractId
					// console.log(this.refid)
					uploaddown.listdownfile({refid:this.contractId, reftype: '合同附件'}).then(res => {
						console.log(res, '合同附件');
						this.fileList = res.obj
					})
				});
			}
		}
	}
</script>

<style scoped>
	.texts{
		color: #2a89d6;
		font-size: 18px;
		text-decoration: underline
	}
</style>
<style>
	/* .h-formbLine .el-form-item__label{
        width: 18%;
    } */
	.yearIcon .el-input:after {
		content: '年';
		font-size: 0.18rem;
		color: #b8b6b6;
		/* font-weight: bold; */
		position: absolute;
		right: 0.15rem;
	}
	.weekplandetail .h-formbLine .el-form-item__label{
		width: 34%;
		text-align: right;
	}
	.weekplandetail .h-formbLine .el-form-item__content{
		width: 66%;
	}
	.weekplandetail .h-formbLine .h-elformWrap-2{
		width: 33.333%;
		padding-right: 0.5rem
	}
	.weekplandetail .h-formbLine .h-elformWrap-1{
		width: 100%;
		padding-right: 0.5rem
	}
	.weekplandetail .h-formbLine .h-elformWrap-1 .el-form-item__label{
		width: 10.4%;
	}
	.weekplandetail .h-formbLine .h-elformWrap-1 .el-form-item__content{
		width: 89.6%;
	}
	.weekplandetail2 .h-formbLine .h-elformWrap-2{
		width: 100%;
		padding-right: 0.5rem
	}
	.weekplandetail2 .h-formbLine .h-elformWrap-2 .el-form-item__label{
		width: 22.4%;
		vertical-align: middle;
	}
	.weekplandetail2 .h-formbLine .h-elformWrap-2 .el-form-item__content{
		width: 77.6%;
	}
	.weekplandetail1 .h-formbLine .h-elformWrap-2{
		width: 100%;
		padding-right: 0.5rem
	}
	.weekplandetail1 .h-formbLine .h-elformWrap-2 .el-form-item__label{
		width: 7%;
		vertical-align: middle;
	}
	.weekplandetail1 .h-formbLine .h-elformWrap-2 .el-form-item__content{
		width: 93%;
	}
	.new-yulan{
		width: 100%;
		margin: 0 auto;
	}
	.new-yulan ul li{
		padding:5px 0
	}
	.new-yulan ul li h3{
		text-align: left;
		font-weight: 400;
		color: #0e75e9;
		font-size: 14px
	}
	.new-yulan ul li h3 i{
		padding: 0 5px;
		color: #606266
	}
	.new-yulan ul li h3 span{
		text-align: right;
		color: #606266;
		float: right;
		font-size: 13px
	}
</style>
